import React from "react";

export const ValidatePhone = (phone) => {
    const regexNorway = /^\d{8}$/;        
        if (regexNorway.test(phone)) {
            return true;
        } else {
            return false;
        }
}